import React, { useEffect, useState } from 'react';

import { Button } from 'bsa-ui';
import { isNil } from 'lodash';
import { FormattedMessage } from 'react-intl';

import { useMbcMessageRecipients } from '@modules/messaging/hooks';
import { Modal, Spin, T } from '@shared/components';

import MBCYouthsMembersList from '../MBCYouthsMembersList';
import styles from './ManageMBCYouthsMembersModal.less';

type ManageMBCYouthsMembersModalProps = {
  visible: boolean;
  recipients: number[];
  onRecipientsUpdate: (memberIds: number[]) => void;
  onCancel: () => void;
};

const ManageMBCYouthsMembersModal: React.FC<
  ManageMBCYouthsMembersModalProps
> = ({ visible, recipients, onRecipientsUpdate, onCancel }) => {
  const [search, setSearch] = useState<string>('');
  const [selectedMemberIds, setSelectedMemberIds] =
    useState<number[]>(recipients);

  const { mbcProfile, youths, counselingBadges, isLoadingMbcProfile } =
    useMbcMessageRecipients();

  useEffect(() => {
    setSelectedMemberIds(recipients);
  }, [recipients]);

  const handleSave = () => {
    onRecipientsUpdate(selectedMemberIds);
    onCancel();
  };

  const handleClose = () => {
    onCancel();
  };

  return (
    <Modal
      noPadding
      visible={visible}
      destroyOnClose
      width="100%"
      onCancel={handleClose}
    >
      <Spin
        delay={100}
        size="large"
        spinning={isNil(mbcProfile) || isLoadingMbcProfile}
      >
        <T size="4" className={styles.header}>
          <FormattedMessage id="messaging.ManageBalanceMembersModal.manageListMembers" />
        </T>
        <MBCYouthsMembersList
          prefix="youth"
          recipients={selectedMemberIds}
          counselingBadges={counselingBadges}
          list={youths}
          search={search}
          setSearch={setSearch}
          onRecipientsUpdate={setSelectedMemberIds}
        />
        <div className={styles.buttonContainer}>
          <Button
            size="large"
            type="primary"
            shape="round"
            onClick={handleSave}
          >
            <FormattedMessage id="shared.save" />
          </Button>
          <Button
            size="large"
            type="danger"
            shape="round"
            onClick={handleClose}
          >
            <FormattedMessage id="shared.close" />
          </Button>
        </div>
      </Spin>
    </Modal>
  );
};

export default ManageMBCYouthsMembersModal;
